import React, { useState } from 'react';

interface FilterBarChangePayload {
  period?: string;
  customStartDate?: string;
  customEndDate?: string;
}

interface FilterBarProps {
  timePeriod: string;
  customStartDate?: string;
  customEndDate?: string;
  onChange: (payload: FilterBarChangePayload) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({ timePeriod, customStartDate, customEndDate, onChange }) => {
  const [showCustomDates, setShowCustomDates] = useState<boolean>(timePeriod === 'custom');

  const handlePeriodChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const newPeriod = e.target.value;
    setShowCustomDates(newPeriod === 'custom');
    onChange({ period: newPeriod });
  };

  const handleCustomDateChange = (field: string, value: string): void => {
    onChange({ [field]: value });
  };

  return (
    <div className="mb-6 bg-white dark:bg-gray-800 shadow rounded-lg p-4">
      <div>
        {/* Time Period Filter */}
        <div>
          <label htmlFor="time-period" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Time Period
          </label>
          <select id="time-period"
            value={timePeriod}
            onChange={handlePeriodChange}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500"
          >
            <option value="last_month">Last Month</option>
            <option value="last_3_months">Last 3 Months</option>
            <option value="last_6_months">Last 6 Months</option>
            <option value="last_12_months">Last 12 Months</option>
            <option value="custom">Custom Range</option>
          </select>
        </div>
      </div>

      {/* Custom Date Range Inputs */}
      {showCustomDates && (
        <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="start-date" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Start Date
              </label>
              <input id="start-date"
                type="date"
                value={customStartDate || ''}
                onChange={(e) => handleCustomDateChange('customStartDate', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label htmlFor="end-date" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                End Date
              </label>
              <input id="end-date"
                type="date"
                value={customEndDate || ''}
                onChange={(e) => handleCustomDateChange('customEndDate', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
          {customStartDate && customEndDate && customStartDate > customEndDate && (
            <p className="mt-2 text-sm text-red-600 dark:text-red-400">
              Start date must be before end date
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default FilterBar;
